import * as Icons from '@element-plus/icons-vue'
import { pinyin } from './pinying'

/**
 * 创建图标
 * @param icon 图标
 */
export function createIconNode(icon: string | VNode | VueComponent) {
  if(!icon) {
    return ''
  }
  if(typeof(icon) === 'string') {
    return (Icons as any)[icon]
  }
  return icon
}

export function chineseToPinYin(l1: string) {
  const l2 = l1.length
  let I1 = ''
  const reg = new RegExp('[a-zA-Z0-9]')
  for (let i = 0; i < l2; i++) {
    const val = l1[i]
    const name = arraySearch(val)
    if (reg.test(val)) {
      I1 += val
    } else if (name !== false) {
      I1 += name
    }
  }
  I1 = I1.replace(/ /g, '-')
  while (I1.indexOf('--') > 0) {
    I1 = I1.replace('--', '-')
  }
  return I1
}

export function arraySearch(l1: string) {  
  for (const name in pinyin) {
    if (pinyin[name].indexOf(l1) !== -1) {
      return ucfirst(name)
    }
  }
  return false
}

export function ucfirst(l1: string) {
  if (l1.length > 0) {
    const first = l1.substring(0, 1).toUpperCase()
    const spare = l1.substring(1, l1.length)
    return first + spare
  }
}